import WaitlistOverlay from './WaitlistOverlay';

export default WaitlistOverlay;
